var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1194 6.91342C13.3707 6.30679 13.5 5.65661 13.5 5C13.5 3.67392 12.9732 2.40215 12.0355 1.46447C11.0979 0.526784 9.82608 0 8.5 0C7.17392 0 5.90215 0.526784 4.96447 1.46447C4.02678 2.40215 3.5 3.67392 3.5 5C3.5 5.65661 3.62933 6.30679 3.8806 6.91342C4.13188 7.52005 4.50017 8.07124 4.96447 8.53553C5.42876 8.99983 5.97995 9.36812 6.58658 9.6194C7.19321 9.87067 7.84339 10 8.5 10C9.15661 10 9.80679 9.87067 10.4134 9.6194C11.02 9.36812 11.5712 8.99983 12.0355 8.53553C12.4998 8.07124 12.8681 7.52005 13.1194 6.91342Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 10.7V15.6039L8.5 14.1039L11.5 15.6039V10.7C11.2737 10.8307 11.0386 10.9467 10.7961 11.0471C10.0681 11.3487 9.28793 11.5039 8.5 11.5039C7.71207 11.5039 6.93185 11.3487 6.2039 11.0471C5.96142 10.9467 5.72632 10.8307 5.5 10.7Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal);
export default __webpack_public_path__ + "static/media/medal.a697bdca8c66c97c60b114d2e1449bdb.svg";
export { ForwardRef as ReactComponent };